module.exports = __webpack_public_path__ + "static/media/home-chargers.855e89fb.svg";